
import React from 'react';
import { MappingRule } from '@/types';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Pencil, X } from 'lucide-react';
import { toast } from 'sonner';

interface MappingRulesTableProps {
  rules: MappingRule[];
  onDeleteRule: (ruleId: string) => void;
  onEditRule?: (rule: MappingRule) => void;
}

export const MappingRulesTable: React.FC<MappingRulesTableProps> = ({
  rules,
  onDeleteRule,
  onEditRule,
}) => {
  // Sort rules by mainAccountFrom numerically
  const sortedRules = [...rules].sort((a, b) => {
    const numA = parseInt(a.mainAccountFrom) || 0;
    const numB = parseInt(b.mainAccountFrom) || 0;
    return numA - numB;
  });

  console.log('Sorted rules:', sortedRules);

  const handleEditClick = (rule: MappingRule) => {
    console.log('Editing rule:', rule);
    if (onEditRule) {
      onEditRule(rule);
    } else {
      toast.error('Edit functionality not implemented');
    }
  };

  return (
    <div className="rounded-md border">
      <div className="h-[calc(100vh-16rem)] overflow-auto">
        <Table>
          <TableHeader className="sticky top-0 bg-white z-10">
            <TableRow>
              <TableHead className="py-2">Account From</TableHead>
              <TableHead className="py-2">Account To</TableHead>
              <TableHead className="py-2">Team From</TableHead>
              <TableHead className="py-2">Team To</TableHead>
              <TableHead className="py-2">Project From</TableHead>
              <TableHead className="py-2">Project To</TableHead>
              <TableHead className="w-[100px] py-2">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedRules && sortedRules.length > 0 ? (
              sortedRules.map((rule) => (
                <TableRow key={rule.id}>
                  <TableCell className="py-1">{rule.mainAccountFrom}</TableCell>
                  <TableCell className="py-1">{rule.mainAccountTo}</TableCell>
                  <TableCell className="py-1">{rule.teamFrom || '-'}</TableCell>
                  <TableCell className="py-1">{rule.teamTo || '-'}</TableCell>
                  <TableCell className="py-1">{rule.projectFrom || '-'}</TableCell>
                  <TableCell className="py-1">{rule.projectTo || '-'}</TableCell>
                  <TableCell className="py-1">
                    <div className="flex space-x-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleEditClick(rule)}
                        className="h-6 w-6"
                      >
                        <Pencil className="h-3 w-3" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onDeleteRule(rule.id)}
                        className="h-6 w-6 text-red-500 hover:text-red-600"
                      >
                        <X className="h-3 w-3" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} className="text-center text-gray-500 py-4">
                  No mapping rules yet. Click "Add Rule" to create one.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
